import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from '../Fields.module.scss';

type FieldWrapperProps = PropsWithChildren<{
  label?: string;
  invalid?: boolean;
}>;

export const FieldWrapper: FC<FieldWrapperProps> = ({
  children,
  label,
  invalid,
}) => {
  return (
    <div className={styles['field-wrapper']}>
      {!!label && (
        <label
          className={classNames(styles['field-wrapper-label'], {
            [styles['invalid']]: invalid,
          })}
        >
          {label}
        </label>
      )}
      {children}
    </div>
  );
};
